import script from "./WorklistTable.vue?vue&type=script&setup=true&lang=js"
export * from "./WorklistTable.vue?vue&type=script&setup=true&lang=js"

import "./WorklistTable.vue?vue&type=style&index=0&id=72b01e35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72b01e35"]])

export default __exports__